import { render, staticRenderFns } from "./MenuPermissionPicker.vue?vue&type=template&id=4268fa9a&scoped=true"
import script from "./MenuPermissionPicker.vue?vue&type=script&lang=js"
export * from "./MenuPermissionPicker.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissionPicker.vue?vue&type=style&index=0&id=4268fa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268fa9a",
  null
  
)

export default component.exports